<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div class="lf-text-body lf-user-feedback-description">{{localizedStrings.YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT | async}}</div>
<div class="lf-text-body lf-user-feedback-description">{{localizedStrings.TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP | async}}</div>
<button id="lf-user-feedback-feedback-mode-button" class="lf-button feedback-suggestion-button"
    (click)="onClickFeedback()">{{localizedStrings.I_HAVE_FEEDBACK | async}}</button>
<button id="lf-user-feedback-suggestion-mode-button" class="lf-button feedback-suggestion-button"
    (click)="onClickSuggestion()">{{localizedStrings.I_HAVE_SUGGESTION | async}}</button>
